import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const PlusChunky = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <polygon
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            points="13,11 13,4 11,4 11,11 4,11 4,13 11,13 11,20 13,20 13,13 20,13 20,11 "
        />
    </svg>
);

export default PlusChunky;
